/**
 * CBE SuperApp WebView bridge types.
 * window.cbesuperapp is injected only inside the CBE SuperApp WebView.
 */

export interface CbeSuperAppBridge {
  send: (payload: string) => void
}

export interface CbeAuthPayload {
  xAccessToken?: string
  xApiKey?: string
  [key: string]: unknown
}

export interface CbeOrderPayload {
  app_code?: string
  merchant_code?: string
  merchant_reference?: string
  title?: string
  total_amount?: number | string
  currency?: string
  sign?: string
  confirm_payload?: string
  [key: string]: unknown
}

export interface CbeCreateOrderRequest {
  /** Appointment id — sent as appointment_id to createChechePayment */
  transaction_id: string
  title: string
  paymentType: "InApp"
  amount: number | string
  /** Optional — backend can generate xAccessToken itself */
  access_token?: string
  type?: string
  paymentMethod?: string
}
//testtest
export interface CbeInitiatePaymentParams {
  orderPayload: CbeOrderPayload
  authPayload: CbeAuthPayload
  callbackName?: string
  appName?: string
}

export interface CbeCreateOrderResult {
  success?: boolean
  paymentType?: string
  title?: string
  amount?: string | number
  merchantReference?: string
  orderPayload: CbeOrderPayload
  authPayload: CbeAuthPayload
  initiatePaymentParams?: CbeInitiatePaymentParams
  appName?: string
  fetchAccessTokenParams?: {
    appcode?: string
    callbackName?: string
  }
  instructions?: Record<string, unknown>
}

export interface CbeCreateOrderResponse {
  success?: boolean
  message?: string
  result: CbeCreateOrderResult
  [key: string]: unknown
}

export interface CbePaymentResult {
  ft_number?: string
  /** Backend may return total_amount as a string — keep as returned */
  total_amount?: string
  [key: string]: unknown
}

export type CbeWindow = Window & {
  cbesuperapp?: CbeSuperAppBridge
  handleAccessToken?: (accessToken: string) => void
  handlePaymentResult?: (result: CbePaymentResult) => void
}

export function getCbeWindow(): CbeWindow {
  return window as CbeWindow
}
